/* DHWD Screen Add-On — product page (PDP) widget
 * Renders inside the product add-to-cart form via snippets/screen-addon-pdp.liquid
 * on every Door/Window product page. Lets the shopper add a size-matched
 * Screen Door / Screen Window alongside the main product in one click by
 * piggybacking on the theme's native "Add to Cart" AJAX call.
 */
(function () {
  if (window.__dhwdScreenAddonPdpInit) return;
  window.__dhwdScreenAddonPdpInit = true;

  function formatMoney(cents) {
    var n = (cents || 0) / 100;
    return '$' + n.toFixed(2);
  }

  function parseSize(str) {
    if (!str) return null;
    var m = String(str).trim().match(/^(\d+)\s*x\s*(\d+)$/i);
    if (!m) return null;
    return { w: parseInt(m[1], 10), h: parseInt(m[2], 10) };
  }

  function nearestSize(targetStr, sizes) {
    var target = parseSize(targetStr);
    if (!target || !sizes.length) {
      return { size: sizes[0] || null, exact: false };
    }
    var best = null;
    var bestDist = Infinity;
    var exactMatch = null;
    for (var i = 0; i < sizes.length; i++) {
      var s = parseSize(sizes[i]);
      if (!s) continue;
      if (s.w === target.w && s.h === target.h) {
        exactMatch = sizes[i];
        break;
      }
      var dist = Math.abs(s.w - target.w) + Math.abs(s.h - target.h);
      if (dist < bestDist) {
        bestDist = dist;
        best = sizes[i];
      }
    }
    if (exactMatch) return { size: exactMatch, exact: true };
    return { size: best || sizes[0] || null, exact: false };
  }

  function uniqueInOrder(arr) {
    var seen = {};
    var out = [];
    for (var i = 0; i < arr.length; i++) {
      if (!seen[arr[i]]) {
        seen[arr[i]] = true;
        out.push(arr[i]);
      }
    }
    return out;
  }

  function populateSelect(select, values, selected) {
    select.innerHTML = '';
    for (var i = 0; i < values.length; i++) {
      var opt = document.createElement('option');
      opt.value = values[i];
      opt.textContent = values[i];
      if (values[i] === selected) opt.selected = true;
      select.appendChild(opt);
    }
  }

  function initRoot(root) {
    if (root.__dhwdInit) return;
    root.__dhwdInit = true;

    var variantsScript = root.querySelector('[data-screen-addon-variants]');
    var allVariants = [];
    try {
      allVariants = JSON.parse((variantsScript && variantsScript.textContent) || '[]');
    } catch (e) {
      allVariants = [];
    }
    var variants = allVariants.filter(function (v) { return v.available; });
    if (!variants.length) {
      root.style.display = 'none';
      return;
    }

    var targetSize = root.getAttribute('data-target-size') || '';
    var checkbox = root.querySelector('[data-screen-addon-checkbox]');
    var panel = root.querySelector('[data-screen-addon-panel]');
    var colorSelect = root.querySelector('[data-screen-addon-color]');
    var openingSelect = root.querySelector('[data-screen-addon-opening]');
    var priceEl = root.querySelector('[data-screen-addon-price]');
    var sizeBadge = root.querySelector('[data-screen-addon-size]');
    var fallbackEl = root.querySelector('[data-screen-addon-fallback]');

    var sizes = uniqueInOrder(variants.map(function (v) { return v.option1; }).filter(Boolean));
    var pick = nearestSize(targetSize, sizes);
    var matchedSize = pick.size;

    if (fallbackEl) fallbackEl.hidden = !!pick.exact;
    if (sizeBadge) sizeBadge.textContent = matchedSize ? ('Size: ' + matchedSize) : '';

    function variantsForSize(size) {
      return variants.filter(function (v) { return v.option1 === size; });
    }

    function colorsForSize(size) {
      return uniqueInOrder(variantsForSize(size).map(function (v) { return v.option2; }).filter(Boolean));
    }

    function openingsForSizeColor(size, color) {
      return uniqueInOrder(
        variantsForSize(size)
          .filter(function (v) { return !color || v.option2 === color; })
          .map(function (v) { return v.option3; })
          .filter(Boolean)
      );
    }

    function currentVariant() {
      var color = colorSelect.value;
      var opening = openingSelect.value;
      var match = variants.filter(function (v) {
        return v.option1 === matchedSize &&
          (!color || v.option2 === color) &&
          (!opening || v.option3 === opening);
      });
      return match[0] || null;
    }

    function updatePrice() {
      var v = currentVariant();
      if (v) {
        if (priceEl) priceEl.textContent = formatMoney(v.price);
        root.setAttribute('data-screen-addon-variant-id', v.id);
      } else {
        if (priceEl) priceEl.textContent = '';
        root.removeAttribute('data-screen-addon-variant-id');
      }
    }

    function refreshOpeningOptions() {
      var openings = openingsForSizeColor(matchedSize, colorSelect.value);
      if (openings.length) {
        populateSelect(openingSelect, openings, openings[0]);
        openingSelect.style.display = '';
      } else {
        openingSelect.innerHTML = '';
        openingSelect.style.display = 'none';
      }
      updatePrice();
    }

    function refreshColorOptions() {
      var colors = colorsForSize(matchedSize);
      if (colors.length) {
        populateSelect(colorSelect, colors, colors[0]);
        colorSelect.style.display = '';
      } else {
        colorSelect.innerHTML = '';
        colorSelect.style.display = 'none';
      }
      refreshOpeningOptions();
    }

    refreshColorOptions();

    colorSelect.addEventListener('change', refreshOpeningOptions);
    openingSelect.addEventListener('change', updatePrice);

    if (checkbox && panel) {
      checkbox.addEventListener('change', function () {
        panel.hidden = !checkbox.checked;
        root.setAttribute('data-screen-addon-active', checkbox.checked ? 'true' : 'false');
      });
    }
  }

  function initAll(scope) {
    var roots = (scope || document).querySelectorAll('[data-screen-addon-root]');
    for (var i = 0; i < roots.length; i++) {
      initRoot(roots[i]);
    }
  }

  // Reads the currently-selected screen variant/quantity for every active,
  // checked addon widget on the page and returns the /cart/add.js payload items.
  function collectAddonItems() {
    var roots = document.querySelectorAll('[data-screen-addon-root]');
    var items = [];
    for (var i = 0; i < roots.length; i++) {
      var root = roots[i];
      var checkbox = root.querySelector('[data-screen-addon-checkbox]');
      var variantId = root.getAttribute('data-screen-addon-variant-id');
      if (checkbox && checkbox.checked && variantId) {
        var qtyInput = document.querySelector('[data-quantity-wrapper] [data-quantity-value]');
        var qty = qtyInput ? parseInt(qtyInput.value, 10) : 1;
        if (!qty || qty < 1) qty = 1;
        items.push({ id: parseInt(variantId, 10), quantity: qty });
      }
    }
    return items;
  }

  function refreshMiniCart() {
    return fetch(window.location.pathname + '?section_id=mini_cart', {
      headers: { 'X-Requested-With': 'XMLHttpRequest' }
    })
      .then(function (res) { return res.text(); })
      .then(function (html) {
        var parser = new DOMParser();
        var doc = parser.parseFromString(html, 'text/html');
        var newMiniCart = doc.querySelector('#t4s-mini_cart') || doc.querySelector('.t4s-mini_cart') || doc.body.firstElementChild;
        var currentMiniCart = document.querySelector('#t4s-mini_cart') || document.querySelector('.t4s-mini_cart');
        if (newMiniCart && currentMiniCart) {
          currentMiniCart.innerHTML = newMiniCart.innerHTML;
        }
        if (window.theme && typeof window.theme.getCart === 'function') {
          try { window.theme.getCart(); } catch (e) {}
        }
        document.dispatchEvent(new CustomEvent('cart:refresh'));
      })
      .catch(function () {});
  }

  var addonBusy = false;
  function triggerAddonAdds() {
    if (addonBusy) return;
    var items = collectAddonItems();
    if (!items.length) return;
    addonBusy = true;
    fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
        'X-Dhwd-Screen-Addon': '1'
      },
      body: JSON.stringify({ items: items })
    })
      .then(function () { return refreshMiniCart(); })
      .catch(function () {})
      .then(function () {
        addonBusy = false;
      });
  }

  // Piggyback on the theme's native add-to-cart AJAX call: once the main
  // product's /cart/add(.js) request succeeds, fire a secondary add for any
  // checked screen add-on(s) — without touching the theme's own submit flow.
  function isCartAddUrl(url) {
    return /\/cart\/add(\.js)?(\?|$)/.test(String(url || ''));
  }

  function headerHasMarker(headers) {
    if (!headers) return false;
    if (typeof headers.get === 'function') return !!headers.get('X-Dhwd-Screen-Addon');
    return !!headers['X-Dhwd-Screen-Addon'];
  }

  if (!window.__dhwdScreenAddonFetchPatched) {
    window.__dhwdScreenAddonFetchPatched = true;
    var originalFetch = window.fetch.bind(window);
    window.fetch = function (input, init) {
      var url = typeof input === 'string' ? input : (input && input.url) || '';
      var method = ((init && init.method) || 'GET').toUpperCase();
      var ownCall = headerHasMarker(init && init.headers);
      if (isCartAddUrl(url) && method === 'POST' && !ownCall) {
        return originalFetch(input, init).then(function (res) {
          if (res && res.ok) {
            window.setTimeout(triggerAddonAdds, 0);
          }
          return res;
        });
      }
      return originalFetch(input, init);
    };
  }

  if (!window.__dhwdScreenAddonXhrPatched) {
    window.__dhwdScreenAddonXhrPatched = true;
    var origOpen = XMLHttpRequest.prototype.open;
    var origSend = XMLHttpRequest.prototype.send;
    XMLHttpRequest.prototype.open = function (method, url) {
      this.__dhwdIsCartAdd = isCartAddUrl(url) && String(method).toUpperCase() === 'POST';
      return origOpen.apply(this, arguments);
    };
    XMLHttpRequest.prototype.send = function () {
      if (this.__dhwdIsCartAdd) {
        this.addEventListener('load', function () {
          if (this.status >= 200 && this.status < 300) {
            window.setTimeout(triggerAddonAdds, 0);
          }
        });
      }
      return origSend.apply(this, arguments);
    };
  }

  function boot() {
    initAll(document);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();